import { createContext } from 'react';
import type { CustomControlCode, ServiceCode } from '@common/enums';
import type { IProcessAction, IProcessActivity, ServiceWorkflowStep } from '@common/interfaces';
import type { PatientData, ProcessData } from '@common/interfaces/serviceContext.types';

export type ProcessActivityContextValue<Code extends ServiceCode = ServiceCode> = Readonly<{
    customControlCode: CustomControlCode;
    customControlVersion: number;
    patientData?: PatientData<Code>;
    processAction?: IProcessAction;
    processActivity?: IProcessActivity;
    processData?: ProcessData<Code>;
    serviceActivity: IProcessActivity['serviceActivity'];
    serviceCode: ServiceCode;
    serviceWorkflowStep?: ServiceWorkflowStep;
}>;

export const ProcessActivityContext = createContext<ProcessActivityContextValue | null>(null);
